import _ from "lodash";

import ExternalLogger from "../../../ExternalLogger";

const SamlTokenService = function ($q, $state, $timeout, accountService, samlTokenFactory) {
    const logger = ExternalLogger.getInstance("SamlTokenService");

    const service = this;

    //This calls the factory to get the SAML Token.
    function getMySamlToken(factoryName) {
        const deferred = $q.defer();
        accountService.setActiveGroupAccount().then((params) => {
            console.log("get my saml token - params", params, "factory", factoryName);

            //If a facotryName is not passed, use the access portal's description.
            if (!factoryName) {
                console.log("set provider url and phone number");
                accountService.setProviderUrlAndPhoneNumberObject().then(
                    function () {
                        factoryName =
                            accountService.urlPhoneNumberData.accessPortalsDTO.accessPortals[0].descr?.replace(
                                / /g,
                                ""
                            );
                        const factoryMethod = "get" + factoryName + "SamlToken";
                        samlTokenFactory[factoryMethod].query(
                            params,
                            function (data) {
                                data.factoryName = factoryName;
                                deferred.resolve(data);
                            },
                            function () {
                                deferred.reject();
                            }
                        );
                        return deferred.promise;
                    },
                    function (err) {
                        console.log(err);
                    }
                );
            } else {
                const factoryMethod = "get" + factoryName + "SamlToken";
                samlTokenFactory[factoryMethod].query(
                    params,
                    function (data) {
                        data.factoryName = factoryName;
                        deferred.resolve(data);
                    },
                    function () {
                        deferred.reject();
                    }
                );
            }
        });
        return deferred.promise;
    }

    //This takes the generated SAMLResponse and/or any additional parameters,
    //and populates a hidden form in the view, then submits it to the provider's web site.
    const getMySamlTokenResult = function (data, ssoWindow, uniqueId) {
        const deferred = $q.defer();
        logger.info("getMySamlTokenResult()");
        const samlResponse = document.createElement("input");
        const relayState = document.createElement("input");
        const ssoIndicator = document.createElement("input");
        const lowerCaseId = document.createElement("input");

        Object.assign(samlResponse, {
            id: "SAMLResponse",
            type: "hidden",
            name: "SAMLResponse"
        });
        Object.assign(relayState, {
            id: "RelayState",
            type: "hidden",
            name: "RelayState"
        });
        Object.assign(ssoIndicator, {
            id: "SSOIndicator",
            type: "hidden",
            name: "SSOIndicator"
        });
        Object.assign(lowerCaseId, {
            type: "hidden"
        });

        document.querySelector(`#SAMLFORM${uniqueId}`).setAttribute("action", data.postUrl);
        _.forOwn(data, function (value, key) {
            if (
                key !== "$promise" &&
                key !== "$resolved" &&
                key !== "factoryName" &&
                key.toLowerCase() !== "posturl"
            ) {
                if (key.toLowerCase() === "samlresponse") {
                    samlResponse.setAttribute("value", value);
                    document.getElementById("SAMLResponse")?.remove();
                    document.getElementById(`SAMLFORM${uniqueId}`).append(samlResponse);
                } else if (key.toLowerCase() === "relaystate") {
                    relayState.setAttribute("value", value);
                    document.getElementById("RelayState")?.remove();
                    document.getElementById(`SAMLFORM${uniqueId}`).append(relayState);
                } else if (key.toLowerCase() === "ssoindicator") {
                    ssoIndicator.setAttribute("value", value);
                    document.getElementById("SSOIndicator")?.remove();
                    document.getElementById(`SAMLFORM${uniqueId}`).append(ssoIndicator);
                } else {
                    lowerCaseId.setAttribute("value", value);
                    lowerCaseId.setAttribute("id", key.toLowerCase());
                    lowerCaseId.setAttribute("name", key);
                    document.getElementById(key.toLowerCase())?.remove();
                    document.getElementById(`SAMLFORM${uniqueId}`).append(lowerCaseId);
                }
            }
        });

        if (data.factoryName === "Milliman") {
            document.querySelector(`#SAMLFORM${uniqueId}`).setAttribute("method", "GET");
        } else {
            document.querySelector(`#SAMLFORM${uniqueId}`).setAttribute("method", "POST");
        }

        if (uniqueId == "Candidly") {
            document.querySelector(`#SAMLFORM${uniqueId}`).setAttribute("target", "_self");
        } else {
            document.querySelector(`#SAMLFORM${uniqueId}`).setAttribute("target", "ssoWindow");
        }

        if (!ssoWindow || ssoWindow.closed || typeof ssoWindow.closed === "undefined") {
            alert(
                "Please allow popups from empower-retirement.com in order to view the provider's website."
            );
            deferred.reject();
        }
        if (!ssoWindow) {
            let errorMessage = "There was an error launching the provider website.";
            if (!ssoWindow || ssoWindow.closed || typeof ssoWindow.closed == "undefined") {
                errorMessage +=
                    " Please allow popups from empower-retirement.com in order to view the provider's website.";
            }
            alert(errorMessage);
            deferred.reject();
        }

        if (ssoWindow) {
            document.querySelector(`#SAMLFORM${uniqueId}`).submit();
            $q.when();
        }

        return deferred.promise;
    };

    //This is the main function to be used in Controllers and Directives.
    service.navigateToken = function (factoryName, ssoWindow, uniqueId) {
        const deferred = $q.defer();
        logger.info("navigateToken()");

        const getMySamlTokenFault = function () {
            logger.info("getMySamlTokenFault()");
        };

        getMySamlToken(factoryName)
            .then(function success(data) {
                return getMySamlTokenResult(data, ssoWindow, uniqueId);
            })
            .then(deferred.resolve)
            .catch(getMySamlTokenFault);

        return deferred.promise;
    };

    //This service returns a promise for whether Total Rewards should show.
    service.showTotalRewardsPromise = function () {
        const deferred = $q.defer();

        samlTokenFactory.showTotalRewards.query(
            function (result) {
                deferred.resolve(result);
            },
            function () {
                deferred.reject();
            }
        );

        return deferred.promise;
    };
};

SamlTokenService.$inject = ["$q", "$state", "$timeout", "accountService", "samlTokenFactory"];
export default SamlTokenService;
